import { render, staticRenderFns } from "./cabinet-show.vue?vue&type=template&id=2d57b24c&scoped=true"
import script from "./cabinet-show.vue?vue&type=script&lang=ts"
export * from "./cabinet-show.vue?vue&type=script&lang=ts"
import style0 from "./cabinet-show.vue?vue&type=style&index=0&id=2d57b24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57b24c",
  null
  
)

export default component.exports